@if (tabs.length > 1 || _level > 1) {
  <abc-tab-panel
    [dataSource]="tabs"
    [loop]="true"
    [animationEnabled]="true"
    [swipeEnabled]="true"
    height="100%"
    >
    <div *dxTemplate="let tab of 'item'">
      <abc-grid
        #grid
        [setupDefaultLayoutOnInitialization]="true"
        [showBorders]="false"
        [columns]="gridColumns.get(tab)"
        [dataSource]="data[tab]"
        height="100%"
      [masterDetail]="{
        enabled: subQueries[tab],
        template: setMasterDetailTemplateData
      }"
        >
      </abc-grid>
    </div>
  </abc-tab-panel>
} @else {
  <abc-grid
    #flatGrid
    [setupDefaultLayoutOnInitialization]="true"
    [showBorders]="false"
    [columns]="gridColumns.get(tabs[0])"
    [dataSource]="data[tabs[0]]"
    height="100%"
    [masterDetail]="{
      enabled: subQueries[tabs[0]],
      template: setMasterDetailTemplateData
    }"
    >
  </abc-grid>
}
